import { useEffect } from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'

import { ConfirmationDialog } from '../../../components/ConfirmationDialog'
import { Header } from '../../../components/Header'
import { DialogBoxProvider } from '../../../contexts/dialogBoxContext'
import { PromotersStayingTimeProvider } from '../../../contexts/promotersStayingTimeContext'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { JWT_TOKEN_KEY_NAME } from '../../../utils/constants'
import { Footer } from '../../protected/components/Footer'

export function ProtectedGuestRoute() {
  const [searchParams] = useSearchParams()

  const [token, , removeToken] = useLocalStorage(JWT_TOKEN_KEY_NAME)

  const guestToken = searchParams.get('guestTokenAccess')

  useEffect(() => {
    if (token) {
      removeToken()
    }
  }, [token, removeToken])

  return !guestToken
    ? <Navigate to="/" replace />
    : (
      <DialogBoxProvider>
        <PromotersStayingTimeProvider>
          <Header />
          <Outlet />
          <ConfirmationDialog />
          <Footer />
        </PromotersStayingTimeProvider>
      </DialogBoxProvider>
      )
}
